import { render } from "./OJ7045F.vue?vue&type=template&id=1e5881c4&scoped=true&ts=true"
import script from "./OJ7045F.vue?vue&type=script&lang=ts"
export * from "./OJ7045F.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\開発\\PSAP\\おくやみシステム\\OJ0000P_Vue\\OJ0000P\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e5881c4"]])

export default __exports__